/**
 * What the leads table needs to show all of its columns at once.
 *
 * antd renders the table at `max(scroll.x, sum of column widths)`, so a
 * `scroll.x` below the real sum is not a smaller table — it is a number that
 * quietly stops describing anything. The design shows every column without a
 * horizontal scroll, and this constant is what that promise is worth: a spec
 * fails if the columns stop adding up to it.
 *
 * At ten columns the promise no longer holds on a 1366-wide screen once the
 * sidebar is off. Hiding a column from Table settings is the escape.
 *
 * +136 for the Appointment column (EAD Lead Activity Quick Details) —
 * the same width as Follow Up, its adjacent sibling.
 *
 * +112 for Engaged Date — the same width as Lead Created beside it.
 *
 * −96 when Operational State narrowed to 96 so Appointment could be shown by
 * default beside Follow Up; its pills wrap instead of sitting side by side.
 */
export const LEADS_TABLE_MIN_WIDTH = 1574

/**
 * antd prepends the row-selection column and gives it no width of its own, so
 * it never appears in the column definitions but does take space.
 */
export const SELECTION_COLUMN_WIDTH = 32

/**
 * Columns a user sees only after switching them on in Table settings. All
 * thirteen add up to LEADS_TABLE_MIN_WIDTH, which a 1440px laptop cannot show:
 * Value and Last Activity started off-screen, behind a scrollbar nobody saw.
 * What is left — customer, project, status, overlays, owner, follow-up,
 * appointment, value, last activity — fits the table area at 1440px. A saved layout wins either
 * way, so anyone who already chose columns keeps them.
 */
export const LEADS_DEFAULT_HIDDEN_COLUMNS = [
  "uid",
  "source",
  "created",
  "engaged_on"
] as const
